import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.css']
})
export class DateRangePickerComponent implements OnInit {
  startDate!: string;
  endDate!: string;

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    this.commonService.dateRange$.subscribe(range => {
      if (range) {
        this.startDate = this.toDateInputString(range.start);
        this.endDate = this.toDateInputString(range.end);
      }
    });
  }

  // Convert UNIX timestamp to 'YYYY-MM-DD' for input[type="date"]
  private toDateInputString(timestamp: number): string {
    return new Date(timestamp).toISOString().split('T')[0];
  }

  // Convert date string to UNIX timestamp and update service
  onDateChange(): void {
    const start = new Date(this.startDate).getTime();
    const end = new Date(this.endDate).getTime();
    this.commonService.updateDateRange(start, end);
  }
}
